var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.25V8H19.5C20.2957 8 21.0587 8.31607 21.6213 8.87868C22.1839 9.44129 22.5 10.2044 22.5 11V16.25",
    stroke: "url(#paint0_linear_13_10457)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20V5",
    stroke: "url(#paint1_linear_13_10457)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.25H22.5V20",
    stroke: "url(#paint2_linear_13_10457)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8H1.5",
    stroke: "url(#paint3_linear_13_10457)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_10457",
    x1: -4.82143,
    y1: 12.125,
    x2: 18.8571,
    y2: 12.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_10457",
    x1: 0.357143,
    y1: 12.5,
    x2: 2.21429,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_10457",
    x1: -22.5,
    y1: 18.125,
    x2: 16.5,
    y2: 18.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13_10457",
    x1: -7.92857,
    y1: 8.5,
    x2: 7.39286,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.3dbf9b9a3eef9ac8238422163de7ae42.svg";
export { ForwardRef as ReactComponent };